/** 资源库三语文案分片 · 画廊/目录树/工具栏/移动端（由 strings.ts 聚合） */
export const resPartGallery = {
  /** 空白右键菜单/卡片菜单：粘贴 */
  resGalleryPaste: { en: "Paste", zh: "粘贴", id: "Tempel" },
  /** 移动端素材操作：拆解报告 */
  resGalleryReport: { en: "Breakdown report", zh: "拆解报告", id: "Laporan bedah" },
  /** 卡片/目录菜单：打开 */
  resGalleryOpen: { en: "Open", zh: "打开", id: "Buka" },
  /** 画廊空态：数字人库为空 */
  resGalleryEmptyDigital: { en: "No characters yet", zh: "暂无数字人", id: "Belum ada karakter" },
  /** 画廊空态：素材库为空 */
  resGalleryEmptyMaterial: { en: "No assets yet", zh: "暂无素材", id: "Belum ada aset" },
  /** 工具栏/移动端：新建文件夹 */
  resGalleryNewFolder: { en: "New folder", zh: "新建文件夹", id: "Folder baru" },
  /** 工具栏主按钮：新建商品 */
  resGalleryCreateProduct: { en: "New product", zh: "新建商品", id: "Produk baru" },
  /** 工具栏主按钮：新建数字人 */
  resGalleryCreateDigital: { en: "New character", zh: "新建数字人", id: "Karakter baru" },
  /** 工具栏主按钮：上传素材 */
  resGalleryUploadAsset: { en: "Upload assets", zh: "上传素材", id: "Unggah aset" },
  /** 工具栏：AI 生图入口（AI 为品牌词不译） */
  resGalleryAiImage: { en: "AI Image", zh: "AI生图", id: "Gambar AI" },
  /** 移动端操作面板：查看素材 */
  resGalleryViewAsset: { en: "View asset", zh: "查看素材", id: "Lihat aset" },
  /** 移动端操作面板：查看商品 */
  resGalleryViewProduct: { en: "View product", zh: "查看商品", id: "Lihat produk" },
  /** 移动端操作面板：查看数字人 */
  resGalleryViewDigital: { en: "View character", zh: "查看数字人", id: "Lihat karakter" },
  /** 移动端操作面板：查看视频 */
  resGalleryViewVideo: { en: "View video", zh: "查看视频", id: "Lihat video" },
  /** 移动端操作面板：播放音频 */
  resGalleryPlayAudio: { en: "Play audio", zh: "播放音频", id: "Putar audio" },
  /** 移动端操作面板：播放音色 */
  resGalleryPlayVoice: { en: "Play voice", zh: "播放音色", id: "Putar suara" },
  /** 移动端筛选：素材类型 */
  resGalleryMaterialType: { en: "Media type", zh: "素材类型", id: "Jenis aset" },
  /** 类型筛选选项：商品 */
  resGalleryProduct: { en: "Product", zh: "商品", id: "Produk" },
  /** 搜索占位：商品库 */
  resGallerySearchProduct: { en: "Search folders or products...", zh: "搜索文件夹或商品...", id: "Cari folder atau produk..." },
  /** 搜索占位：素材库 */
  resGallerySearchMaterial: { en: "Search folders or assets...", zh: "搜索文件夹或素材...", id: "Cari folder atau aset..." },
  /** 移动端搜索默认占位 */
  resGallerySearchPlaceholder: { en: "Search...", zh: "搜索...", id: "Cari..." },
  /** 卡片/批量栏：剪切 */
  resGalleryCut: { en: "Cut", zh: "剪切", id: "Potong" },
  /** 卡片菜单/移动弹窗标题：移动到 */
  resGalleryMoveTo: { en: "Move to", zh: "移动到", id: "Pindahkan ke" },
  /** 移动弹窗确认按钮 */
  resGalleryConfirmMove: { en: "Move here", zh: "确定移动", id: "Pindahkan ke sini" },
  /** 批量栏：移动 */
  resGalleryMove: { en: "Move", zh: "移动", id: "Pindahkan" },
  /** 批量栏：取消全选 */
  resGalleryUnselectAll: { en: "Deselect all", zh: "取消全选", id: "Batal pilih semua" },
  /** 批量栏计数前缀：已选（与后缀夹住高亮数字） */
  resGallerySelectedPrefix: { en: "Selected", zh: "已选", id: "Dipilih" },
  /** 批量栏计数后缀：项（英文不补词） */
  resGallerySelectedSuffix: { en: "", zh: "项", id: "item" },
  /** 卡片标题兜底：未命名 */
  resGalleryUnnamed: { en: "Untitled", zh: "未命名", id: "Tanpa nama" },
  /** 编辑弹窗标题：图片 */
  resGalleryEditImage: { en: "Edit image", zh: "编辑图片", id: "Edit gambar" },
  /** 编辑弹窗标题：视频 */
  resGalleryEditVideo: { en: "Edit video", zh: "编辑视频", id: "Edit video" },
  /** 编辑弹窗标题：音频 */
  resGalleryEditAudio: { en: "Edit audio", zh: "编辑音频", id: "Edit audio" },
  /** 编辑弹窗标题：音色 */
  resGalleryEditVoice: { en: "Edit voice", zh: "编辑音色", id: "Edit suara" },
  /** 编辑弹窗标题：素材 */
  resGalleryEditAsset: { en: "Edit asset", zh: "编辑素材", id: "Edit aset" },
  /** 编辑弹窗字段：素材名称 */
  resGalleryAssetName: { en: "Asset name", zh: "素材名称", id: "Nama aset" },
  /** 编辑弹窗字段：素材描述 */
  resGalleryAssetDesc: { en: "Asset description", zh: "素材描述", id: "Deskripsi aset" },
  /** 编辑弹窗字段：图片描述 */
  resGalleryImageDesc: { en: "Image description", zh: "图片描述", id: "Deskripsi gambar" },
  /** 编辑校验：字段必填（{label} 为字段名） */
  resGalleryNameRequired: { en: "Enter {label}", zh: "请输入{label}", id: "Masukkan {label}" },
  /** 卡片日期：同年 M月D日 */
  resGalleryDateMd: { en: "{m}/{d}", zh: "{m}月{d}日", id: "{d}/{m}" },
  /** 卡片日期：跨年 Y年M月D日 */
  resGalleryDateYmd: { en: "{y}/{m}/{d}", zh: "{y}年{m}月{d}日", id: "{d}/{m}/{y}" },
  /** 关系画板节点兜底角色：基底形象 */
  resGalleryDhBaseRole: { en: "Base character", zh: "基底形象", id: "Karakter dasar" },
  /** 关系画板节点兜底角色：衍生形象 */
  resGalleryDhDerivedRole: { en: "Derived character", zh: "衍生形象", id: "Karakter turunan" },
  /** 关系画板基底节点详情（{name} 为数字人名） */
  resGalleryDhBaseDetail: {
    en: "{name} is the base character; multiple looks can be derived from it.",
    zh: "{name}的基底形象，可通过形象衍生生成多种造型分身。",
    id: "{name} adalah karakter dasar, dapat diturunkan menjadi berbagai penampilan.",
  },
  /** 关系画板衍生节点详情（{name} 为父级名，{desc} 为衍生描述） */
  resGalleryDhDerivedDetail: {
    en: "Derived from \"{name}\" via character derivation. Description: {desc}.",
    zh: "由「{name}」通过形象衍生生成，衍生描述：{desc}。",
    id: "Diturunkan dari \"{name}\" melalui derivasi karakter. Deskripsi: {desc}.",
  },
  /** 关系卡片音色兜底名 */
  resGalleryVoiceBound: { en: "Bound voice", zh: "已绑定音色", id: "Suara terikat" },
} as const;
